import { DelayCollectionModel } from "../../Model/DelayListCollection";

// Define the initial state for the fltopsDelays reducer
const initialState = {
  fltopsDelaysList: [] as DelayCollectionModel[],
  loading: false,
  error: null as string | null,
};

// The fltopsDelaysReducer function handles actions related to fetching flight operations delays
const fltopsDelaysReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case 'FETCH_FLTOPS_DELAYS_REQUEST':
      // When a request to fetch fltops delays is made, set loading to true and clear any errors
      return { ...state, loading: true, error: null };
    case 'FETCH_FLTOPS_DELAYS_SUCCESS':
      // When fltops delays are successfully fetched, update the fltopsDelaysList array and set loading to false
      return { ...state, loading: false, fltopsDelaysList: action.payload, error:null };
    case 'FETCH_FLTOPS_DELAYS_FAILURE':
      // When there is an error fetching fltops delays, set the error message and set loading to false
      return { ...state, loading: false, error: action.payload };
    default:
      // For any other action types, return the current state
      return state;
  }
};

export default fltopsDelaysReducer;
